import { apiClient } from "../../../services/apiClient";
import { API_ENDPOINTS } from "../../../config/apiEndpoints";

export const userService = {
  getProfile: async () => {
    return apiClient.get(API_ENDPOINTS.USER.PROFILE);
  },

  updateProfile: async (data) => {
    return apiClient.put(API_ENDPOINTS.USER.PROFILE, data);
  },

  getSettings: async () => {
    return apiClient.get(API_ENDPOINTS.USER.SETTINGS);
  },

  updateSettings: async (data) => {
    return apiClient.put(API_ENDPOINTS.USER.SETTINGS, data);
  },

  setDefaultAffiliate: async (affiliateCode) => {
    return apiClient.put(API_ENDPOINTS.USER.DEFAULT_AFFILIATE, {
      AFFILIATE_CODE: affiliateCode,
    });
  },
};
